import { computed, defineComponent } from 'vue'
import type { ExtractPropTypes, CSSProperties } from 'vue'
import classNames from '../_antd_util/classNames'
import OrionError from '../../error/OrionError'

export const colProps = () => ({
  gutter: [Boolean, String],
  height: String,
})

export type ColProps = Partial<ExtractPropTypes<ReturnType<typeof colProps>>>

export default defineComponent({
  name: 'OColflex',
  inheritAttrs: false,
  props: colProps(),
  setup(props, { slots, attrs, emit, expose }) {
    const style = computed(() => {
      const rowStyle: CSSProperties = {}
      rowStyle.gap = props.gutter === true || props.gutter === '' ? `var(--orion-flex-gutter)` : props.gutter ? props.gutter : undefined

      if (props.height) {
        if (props.height == 'fill') {
          throw new OrionError(`OColflex的height无法配置为['fill'],可以设置的值如['need', '100%', '200px']，请检查!`)
        } else if (props.height == 'need') {
        } else {
          rowStyle.height = props.height
        }
      } else {
        rowStyle.height = '100%'
      }

      return rowStyle
    })

    return () => {
      const children = slots.default?.()

      const cn = classNames('orion-flex', 'orion-flex-column')

      return (
        <div class={[cn, attrs.class]} style={[style.value, attrs.style as CSSProperties]}>
          {children}
        </div>
      )
    }
  },
})
